import CaaChatbot from './components/CaaChatbot.vue';

const caaChatbotApp = {
    components: {
        CaaChatbot,
    },
    data() {
        const dataset = document.getElementById('caa-chatbot')?.dataset || {};

        return {
            host: dataset.host ? dataset.host.replace(/\/$/, '') : dataset.host,
            brand: dataset.brand,
            audience: dataset.audience,
            language: dataset.language,
            title: dataset.title,
            logoUrl: dataset.logourl,
            openChatLabel: dataset.openchatlabel,
            closeChatLabel: dataset.closechatlabel,
            newConversationLabel: dataset.newconversationlabel,
            thinkingLabel: dataset.thinkinglabel,
            inputPlaceholder: dataset.inputplaceholder,
            sendLabel: dataset.sendlabel,
            examplesLabel: dataset.exampleslabel,
            unreadableStreamError: dataset.unreadablestreamerror,
            emptyResponseLabel: dataset.emptyresponselabel,
            sourcesLabel: dataset.sourceslabel,
            networkErrorLabel: dataset.networkerrorlabel,
            errorResponse401: dataset.errorresponse401,
            errorResponse403: dataset.errorresponse403,
            errorResponse429: dataset.errorresponse429,
            retryAfterSecondsLabel: dataset.retryaftersecondslabel,
            retryLaterLabel: dataset.retrylaterlabel,
            genericErrorLabel: dataset.genericerrorlabel,
        };
    },
};

export default caaChatbotApp;
